import { render, staticRenderFns } from "./LastBlock.vue?vue&type=template&id=37a883e6"
import script from "./LastBlock.vue?vue&type=script&lang=js"
export * from "./LastBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports